import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function WeekNavCard({ weekLabel, weekAnchor, loading, onShiftWeek, onResetWeek }) {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, py: 1 }}>
        <IconButton size="small" onClick={() => onShiftWeek(-7)} disabled={loading}>
          <ChevronLeftIcon />
        </IconButton>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="subtitle1" fontWeight={600}>
            {weekLabel || "This week"}
          </Typography>
          {weekAnchor && (
            <Button size="small" onClick={onResetWeek} disabled={loading}>
              This week
            </Button>
          )}
        </Box>
        <IconButton size="small" onClick={() => onShiftWeek(7)} disabled={loading}>
          <ChevronRightIcon />
        </IconButton>
      </CardContent>
    </Card>
  );
}

export default WeekNavCard;
